import { createReducer } from "../../../_common/common";
import { SET_ACADEMIC_PROGRAM_CERTIFICATES } from "../actions/constants";

const initialState = {
    academicProgramCertificates: {}
}
export const certificates = createReducer(initialState, {
    [SET_ACADEMIC_PROGRAM_CERTIFICATES]: (state, {academicProgramId, certificates}) => ({
        ...state,
        academicProgramCertificates: {
            ...state.academicProgramCertificates,
            [academicProgramId]: certificates
        }
    })
});
